// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"64":"8470665d","769":"b3cbb36b"}[chunkId] + ".chunk.css";
};